<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("types")}}</h4>
                <p class="text-subtitle-1">{{$t("list_of_vehicles_types")}}</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-2">
            <v-col cols="12" md="3" v-if="hasPermission(permissions.vehicle_usage.create)">
                <v-btn block color="primary" @click="$router.push({ name: 'VehicleUsageCreate' })">
                    <v-icon left>mdi-plus</v-icon>
                    {{$t("add vehicle type")}}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="data"
                    :loading="loading"
                    hide-default-footer
                    disable-pagination
                    disable-sort
                >
                    <template v-slot:[`item.name`]="{item}">
                        <v-btn icon @click="handleClickRow(item)" v-if="hasPermission(permissions.vehicle_usage.read)">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        {{item.name}}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import service from "./../../services/fleet/vehicleUsage";
import permissions from "../../data/permissions";
import authorize from "../../utils/authorize";
export default {
    name: "VehicleUsageListView",
    data() {
        return {
            headers: [
                { text: this.$t('name'), value: "name" },
            ],
            data: [],
            loading: false,
            permissions
        }
    },
    methods: {
        hasPermission(code) {
            return authorize(code)
        },
        fetchVehicleUsages() {
            this.loading = true;
            service.list().then(response => {
                this.data = response.data
            }).finally(() => {
                this.loading = false;
            })
        },
        handleClickRow(vehicleUsage) {
            this.$router.push({ name: "VehicleUsageDisplay" , params: { vehicleUsageID : vehicleUsage.id } })
        }
    },
    created() {
        this.fetchVehicleUsages()
    }
}
</script>

<style>

</style>